import React, {
  FC,
  useState,
  useEffect,
  InputHTMLAttributes,
  TextareaHTMLAttributes,
  ReactNode,
} from 'react';
import cls from './Input.module.scss';
import { UseFormRegisterReturn } from 'react-hook-form';
import ErrorExtra from 'src/components/common/ErrorExtra';
import { errorTextType } from 'src/models/types';
import { useTranslation } from 'react-i18next';
export enum InputTheme {
  TRANSPARENT = 'transparent',
  TEXTAREA_BORDERED = 'textarea-bordered',
  TEXTAREA_DASHED = 'textarea-dashed',
}

export interface InputProps {
  value?: string;
  theme?: InputTheme;
  className?: string;
  wrapperClassName?: string;
  errorText?: errorTextType;
  onChange?: (value: string) => void;
  disabled?: boolean;
  register?: UseFormRegisterReturn;
  isTextArea?: boolean;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  textareaProps?: TextareaHTMLAttributes<HTMLTextAreaElement>;
  disabledPlaceholderOnNull?: boolean;
  textareaTopElement?: ReactNode;
  dataQaSelector?: string;
  errorClassName?: string;
}
const Input: FC<InputProps> = ({
  value,
  theme = InputTheme.TRANSPARENT,
  onChange,
  className = '',
  disabled,
  wrapperClassName,
  register = {},
  errorText,
  inputProps,
  disabledPlaceholderOnNull = true,
  textareaProps,
  isTextArea,
  textareaTopElement,
  dataQaSelector = '',
  errorClassName,
}) => {
  const { t: tg } = useTranslation('translation');

  const [inpValue, setInpValue] = useState(value);

  const onChangeInp = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setInpValue(e.target.value);
    onChange && onChange(e.target.value);
  };

  useEffect(() => {
    setInpValue(value);
  }, [value]);

  return theme !== InputTheme.TEXTAREA_BORDERED && !isTextArea ? (
    <div className={`${cls['input-wrapper']} ${wrapperClassName}`}>
      <input
        {...register}
        className={`input ${cls.input} ${theme && cls[theme]} ${className} ${
          disabled && cls['input-disabled']
        }`}
        disabled={disabled}
        {...(disabledPlaceholderOnNull
          ? { placeholder: tg('select-no-value') }
          : {})}
        {...(onChange
          ? {
              value: inpValue,
              onChange: onChangeInp,
            }
          : {})}
        data-qa-selector={dataQaSelector}
        {...inputProps}
      />
      <ErrorExtra errorText={errorText} className={errorClassName} />
    </div>
  ) : (
    <div className={`${cls['textarea-wrapper']} ${wrapperClassName}`}>
      {textareaTopElement && (
        <div className={cls['textarea-top-element']}>{textareaTopElement}</div>
      )}
      <textarea
        {...register}
        disabled={disabled}
        className={`${cls.textarea} ${theme && cls[theme]} ${className}`}
        data-qa-selector={dataQaSelector}
        {...(onChange
          ? {
              value: inpValue,
              onChange: onChangeInp,
            }
          : {})}
        {...textareaProps}
      />
      <ErrorExtra errorText={errorText} className={errorClassName} />
    </div>
  );
};
export default Input;
